import script from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=60c0bf76&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c0bf76"]])

export default __exports__